<style scoped> 
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="col-sm-12 mb-4">
        <div class="form-group mb-2 mb-md-0">
            <label class="label">{{ label }}</label>
            <div style="display: flex; align-items: center; gap: 4px;">
                <div style="width: 95%;">
                    <app-input
                        type="date"
                        v-model="selected"
                        placeholder="Enter month, day, year."
                        :disabled="is_view"
                    />
                </div>
                <div style="width: 5%; text-align: center;">
                    <button
                        v-if="value && !is_view"
                        type="button"
                        @click="clearSelection"
                        style="background: none; border: none; cursor: pointer; color: #6c757d; font-size: 16px; padding: 0; width: 100%;"
                    >
                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'InputDate',
        props: {
            label : {
                type : String,
                default : ''
            },
            value: {
                type: [String, Number, Object, Date],
                default: null
            },
            is_view : {
                type : Boolean,
                default : false
            }
        },
        methods: {
            clearSelection() {
                this.$emit('input', null);
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>